import AccountService from './AccountService';

export {
    AccountService,
};
export default AccountService;
